import ServiceContent from "@/model/Content/ServiceContent"

export interface IParkingServiceContent {

}

class ParkingServiceContent extends ServiceContent implements IParkingServiceContent {

    constructor() {
        super()
    }

}

export default ParkingServiceContent